/**
 * ITER300 — Context-aware "Back to ..." breadcrumb for drill-down pages.
 *
 * Behaviour:
 *   • Only renders when the user arrived via a KPI click (i.e. the caller
 *     pushed `state: { from: '/admin/ops-command', fromLabel: 'Command Centre' }`
 *     onto the history entry).
 *   • Never rendered on top-level dashboards.
 *   • Clicking navigates back to the originating dashboard preserving the
 *     browser history stack (uses navigate(from), NOT navigate(-1), so
 *     deep-linked drill-downs still return to a sensible root).
 */
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function BackToDashboard({ fallbackLabel = null, fallbackTo = null }) {
  const location = useLocation();
  const navigate = useNavigate();
  const from = location.state?.from || fallbackTo;
  const fromLabel = location.state?.fromLabel || fallbackLabel;
  if (!from) return null;

  return (
    <button
      onClick={() => navigate(from)}
      data-testid="back-to-dashboard"
      className="inline-flex items-center gap-1.5 text-[12px] font-medium
                 text-[color:var(--color-primary)] hover:text-[color:var(--color-primary-hover)]
                 hover:underline transition-colors mb-3"
    >
      <ArrowLeft className="w-3.5 h-3.5" strokeWidth={2} />
      Back to {fromLabel || 'dashboard'}
    </button>
  );
}
